export default "/images/vendor/flag-icons/flags/4x3/af.svg?b5db9810983fc757b017b24631f7ea74";